class BrandSwitcher {
  constructor() {
    this.storageKey = 'store_brand';
    this.brandToggleButtons = document.querySelectorAll('.brand-toggle');
    if (!this.brandToggleButtons.length) return;
    this.init();
  }

  getFooterButtons() {
    return document.querySelectorAll(
      '.brand-footer-bottom-group .brand-toggle'
    );
  }

  syncFooterButtons(brandHandle) {
    const footerButtons = this.getFooterButtons();
    footerButtons.forEach((footerButton) => {
      const fbHandle = footerButton.getAttribute('data-brand-handle') || footerButton.dataset.brandHandle;
      setTimeout(() => {
        footerButton.classList.toggle('active', fbHandle === brandHandle);
      },500)
      footerButton.classList.add('active');
    });
  }

  goToBrandUrl(brandHandle, urlPath) {
    const url = new URL(urlPath, window.location.origin);
    url.searchParams.set('store_brand', brandHandle);
    window.location.href = url.toString();
  }

  handleBrandClick(button) {
    const brandHandle = button.getAttribute('data-brand-handle');
    const brandUrl = button.getAttribute('data-brand-url') || window.location.pathname;
    localStorage.setItem(this.storageKey, brandHandle);
    this.brandToggleButtons.forEach((btn) => btn.classList.remove('active'));
    button.classList.add('active');

    this.syncFooterButtons(brandHandle);
    this.updateAllLinks(brandHandle);
    this.goToBrandUrl(brandHandle, brandUrl);
  }

  attachListeners() {
    this.brandToggleButtons.forEach((button) => {
      button.addEventListener('click', (e) => {
        e.preventDefault();
        this.handleBrandClick(button);
      });
    });
  }

  autoSelectBrand() {
    const url = new URL(window.location.href);
    const urlBrand = url.searchParams.get('store_brand');
    let found = false;
    let activeBrand = null;
    let forceUpdate = document.querySelector('[data-force-brand]')?.getAttribute('data-force-brand');

    if (urlBrand && !forceUpdate) {
      this.brandToggleButtons.forEach((button) => {
        if (!found && button.getAttribute('data-brand-handle') === urlBrand) {
          button.classList.add('active');
          found = true;
          activeBrand = urlBrand;
        } else {
          button.classList.remove('active');
        }
      });
      this.syncFooterButtons(urlBrand);
    } else {
      if (forceUpdate) {
          localStorage.setItem(this.storageKey, forceUpdate);
          url.searchParams.set('store_brand', forceUpdate);
      }
      const storedBrand = localStorage.getItem(this.storageKey);
      if (storedBrand) {
        const footerButtons = document.querySelectorAll('.brand-footer-bottom-group .brand-toggle')
        this.brandToggleButtons.forEach((button) => {
          if (!found && button.getAttribute('data-brand-handle') === storedBrand) {
            button.classList.add('active');
            found = true;
            activeBrand = storedBrand;
            this.syncFooterButtons(storedBrand);
          } else {
            button.classList.remove('active');
          }
        });
      }
      if (!found && this.brandToggleButtons.length > 0) {
        this.brandToggleButtons[0].classList.add('active');
        activeBrand = this.brandToggleButtons[0].getAttribute('data-brand-handle');
        this.syncFooterButtons(activeBrand);
      }
    }
    this.updateAllLinks(activeBrand);
  }

  updateAllLinks(brandHandle) {
    if (!brandHandle) return;
  
    const links = document.querySelectorAll('a[href]');
  
    links.forEach((link) => {
      const href = link.getAttribute('href') || '';
  
      // Skip non-navigational or opted-out links
      if (
        href.startsWith('#') ||
        href.startsWith('javascript:') ||
        href.startsWith('mailto:') ||
        href.startsWith('tel:') ||
        link.hasAttribute('data-no-brand')
      ) return;
  
      let url;
      try {
        url = new URL(href, window.location.origin);
      } catch (err) {
        console.error('BrandSwitcher: Invalid href skipped ', href, err);
        return;
      }
  
      // (same store)
      if (url.origin !== window.location.origin) return;
  
      // Don’t rewrite if already correct
      if (url.searchParams.get('store_brand') === brandHandle) return;
  
      url.searchParams.set('store_brand', brandHandle);
      link.href = url.toString();
    });
  }

  removeBrandFromSearchParams() {
    const url = new URL(window.location.href);
    url.searchParams.delete('store_brand');
    window.history.replaceState({}, '', url.toString());
  }

  init() {
    this.attachListeners();
    this.autoSelectBrand();
    this.removeBrandFromSearchParams();
  }
}

window.addEventListener('DOMContentLoaded', function () {
  new BrandSwitcher();
});
